import React, { ReactNode } from 'react';

import { UserWithHotel } from '../../../../../queries/usersQuery';

type IsStaffRowProps = {
  data: UserWithHotel;
};

// Flaga `isStaff` z dokumentu `users/{uid}` — zielona kropka tylko dla personelu,
// konta bez flagi zostawiamy puste (nie mylimy tego z błędem odczytu).
export const IsStaffRow = ({ data }: IsStaffRowProps): ReactNode => (
  <div className="w-full flex justify-center items-center h-[40px]">
    {data.isStaff && (
      <span
        className="w-2.5 h-2.5 rounded-full bg-green-500"
        title="Staff"
        aria-label="Staff"
      />
    )}
  </div>
);
